export const useLot = defineStore('lotStore', {
  state: () => ({
    lot: null,
    lotToEdit: null,
    scheduleToEdit: null,
    lockId: null,
  }),
  actions: {
    setLot(lot) {
      this.lot = lot;
    },
    setLockId(id) {
      // THIS IS SPECIFICALLY FOR HOURLY RESERVATIONS
      // WITHOUT IT THE LOCKID IS OVERWRITTEN
      this.lockId = id;
    },
    setLotToEdit(lot) {
      this.lotToEdit = lot;
    },
    resetLotToEditSpots(spots) {
      this.lotToEdit.spots = spots;
    },
    setScheduleToEdit(scheduleToEdit, lot) {
      this.scheduleToEdit = scheduleToEdit;
      this.scheduleToEdit.zoneId = lot.id;
    },
    setLotCheckinCheckout(checkin, checkout) {
      this.lot.checkin_date = checkin,
      checkout ? this.lot.checkout_date = checkout : null;
    },
    removeLotParkingSchedule(parkingScheduleId) {
      if (this.lotToEdit && this.lotToEdit.parkingSchedules) {
        this.lotToEdit.parkingSchedules = this.lotToEdit.parkingSchedules.filter(
          schedule => schedule.id !== parkingScheduleId
        );
      }
    },
  },
  getters: {
    canPackBeUsedToday: () => {
      // get day of the week name
      const dayOfWeek = new Date().getDay();
      return dayOfWeek;
    },
  },
  persist: {
    storage: piniaPluginPersistedstate.sessionStorage(),
  },
});
